// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6610":"2b03ebbfa618055a","9769":"b2bb9aefda0b9441"}[chunkId] + ".js";
};